import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import FormX from 'sb-formx'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { constants, compose } from 'common/helpers'
import { required } from 'helpers/validation'
import cx from 'classnames'
import { FormattedHTMLMessage } from 'sb-react-intl'

import injectGlobals from 'decorators/injectGlobals'

import Box from 'components/_new/layout/Box/Box'
import Modal from 'components/modal/Modal/Modal'
import Field from 'components/_new/forms/Field/Field'
import Button from 'components/buttons/Button/Button'
import AgeSelect from 'components/_new/compositions/forms/AgeSelect/AgeSelect'
import SkinTypeSelect from 'components/_new/compositions/forms/SkinTypeSelect/SkinTypeSelect'

import ShareToggler from '../ShareToggler/ShareToggler'
import SelectRating from '../SelectRating/SelectRating'

import messages from './messages'
import s from './ReviewEditModal.scss'


const form = new FormX({
  name: 'ReviewForm',
  fields: {
    title: [ required ],
    text: [ required ],
    rating: [ required ],
    ageCategory: [],
    skinType: [],
  },
})

class ReviewEditModal extends Component {

  static propTypes = {
    name: PropTypes.string,
    title: PropTypes.object,
    data: PropTypes.object,
    product: PropTypes.shape({
      id: PropTypes.number,
      img: PropTypes.string,
      name: PropTypes.string,
      brand: PropTypes.string,
      category: PropTypes.string,
    }).isRequired,
    isNewParamsToReviewsEnabled: PropTypes.bool,
  }

  static defaultProps = {
    name: constants.modals.review.ReviewEdit,
    data: {
      userReview: {},
    },
  }

  constructor({ data }) {
    super()

    const { userReview: { rating, ageCategory, skinType, text, title = '' } } = data

    form.setInitialValues({ rating, title, text, ageCategory, skinType })

    this.state = {
      isFetching: false,
    }
  }

  componentDidMount() {
    actions.models.facebook.init()
  }

  componentWillUnmount() {
    form.unsetValues()
  }

  setFetching = (status) => {
    this.setState({ isFetching: status })
  }

  handleSubmit = () => {
    const {
      name, product: { id: productId },
      data: { userReview: { id: reviewId }, onReviewEdited },
    } = this.props

    form.submit()
      .then((values) => {
        this.setFetching(true)

        actions.models.review.edit({
          review: values,
          reviewId,
          productId,
        })
          .then(
            () => {
              if (typeof onReviewEdited === 'function') {
                onReviewEdited(productId)
              }

              actions.models.modals.close(name)
            },
            () => this.setFetching(false)
          )
      })
  }

  render() {
    const { isFetching } = this.state
    const {
      name: modalName, isNewParamsToReviewsEnabled,
      product: { img, brand, name, category }, data: { userReview },
    } = this.props

    return (
      <Modal className={s.modal} name={modalName}>
        <FormattedHTMLMessage className={s.title} tag="div" {...messages.title} />
        {
          !userReview && (
            <img className={s.previewImage} src={img} alt={`${category} preview`} />
          )
        }
        <div className={s.brand}>{brand}</div>
        <div className={s.name}>{name}</div>
        <div className={s.category}>{category}</div>
        <div className={s.rowItem}>
          <SelectRating field={form.fields.rating} />
          <Field
            className={s.rowItem}
            field={form.fields.title}
            placeholder={messages.titleLabel}
            standardView
          />
          <Field
            className={s.rowItem}
            field={form.fields.text}
            label={messages.reviewPlaceholder}
            type="text"
            placeholder={messages.reviewPlaceholder}
            standardView
            rows={9}
          />
          {
            isNewParamsToReviewsEnabled ? (
              <Fragment>
                <FormattedHTMLMessage className={cx(s.hint, s.rowItem)} tag="div" {...messages.hint} />
                <div className={cx(s.rowItem, s.additionalBox)}>
                  <div style={{ display: 'flex' }}>
                    <AgeSelect field={form.fields.ageCategory} />
                    <Box ml="24">
                      <SkinTypeSelect field={form.fields.skinType} />
                    </Box>
                  </div>
                  <ShareToggler className={s.shareToggler} />
                </div>
              </Fragment>
            ) : (
              <ShareToggler className={cx(s.rowItem, s.shareToggler)} />
            )
          }
          <div className={s.buttons}>
            <Button
              xlg
              brand
              doublePadding
              loading={isFetching}
              onClick={this.handleSubmit}
              title={messages.save}
            />
          </div>
        </div>
      </Modal>
    )
  }
}


export default compose(
  injectGlobals(({ getFeatureToggle }) => ({
    isNewParamsToReviewsEnabled: getFeatureToggle(constants.features.newParamsToReviews),
  })),
  connect({
    product: 'models.review.product',
  }),
)(ReviewEditModal)
